import { loan_application_api, person_api } from '@axo/shared/data-access/api';
import { Handler } from '../api-orchestrator';
import { person } from '@axo/shared/data-access/types';
import { IPreconditions } from '../types/IPreconditions';

interface IDependencies {
  getPerson: typeof person_api.getPerson;
  postPerson: typeof person_api.postPerson;
  patchPerson: typeof person_api.patchPerson;
  patchLoanApplication: typeof loan_application_api.patchLoanApplication;
}

export const coPersonHandlerFactory =
  ({
    getPerson,
    postPerson,
    patchPerson,
    patchLoanApplication,
  }: IDependencies): Handler<person.UpdatePerson, IPreconditions> =>
  async ({
    data,
    preconditions: { customerJWT, loanApplicationId, coPersonId },
    baseUrl,
  }) => {
    if (!customerJWT || !loanApplicationId) {
      return { didSync: false };
    }

    const api = { url: { service: baseUrl }, token: customerJWT };

    if (!data.SocialSecurityNumber) {
      if (coPersonId) {
        await patchLoanApplication(api)(loanApplicationId, {
          CoApplicantPersonID: null,
        });

        return {
          didSync: true,
          newPreconditions: {
            coPersonId: undefined,
          },
        };
      }

      return { didSync: false };
    }

    if (coPersonId) {
      const dbCoPerson = await getPerson(api)(coPersonId);

      if (dbCoPerson.SocialSecurityNumber === data.SocialSecurityNumber) {
        await patchPerson(api)(coPersonId, data);
        return { didSync: true };
      }
    }

    const coPerson = await postPerson(api)(data as person.Person);

    await patchLoanApplication(api)(loanApplicationId, {
      CoApplicantPersonID: coPerson.ID,
    });

    return {
      didSync: true,
      newPreconditions: {
        coPersonId: coPerson.ID ?? undefined,
      },
    };
  };
